export const CosmicBackground = () => (
  <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" aria-hidden="true">
    <div className="absolute inset-0 stars-layer-1" />
    <div className="absolute inset-0 stars-layer-2" />
    <div
      className="absolute -top-40 -left-40 w-[55vw] h-[55vw] rounded-full opacity-25 blur-[120px] animate-float-slow"
      style={{ background: "radial-gradient(circle, #3b2d7a 0%, transparent 70%)" }}
    />
    <div
      className="absolute top-1/3 -right-48 w-[48vw] h-[48vw] rounded-full opacity-20 blur-[130px] animate-float-slow"
      style={{ background: "radial-gradient(circle, #274f6d 0%, transparent 70%)", animationDelay: "2s" }}
    />
    <div
      className="absolute bottom-0 left-1/4 w-[42vw] h-[42vw] rounded-full opacity-[0.15] blur-[120px] animate-float-slow"
      style={{ background: "radial-gradient(circle, #6b2c5f 0%, transparent 70%)", animationDelay: "4s" }}
    />
  </div>
);
